<template>
    <div>
        <section>
            <div class="container">
                <!-- title and ADD column -->
                <div class="columns is-mobile">
                    <div class="column">
                        <p class="title has-text-left">Experimental Datasets</p>
                    </div>
                    <div class="column">
                        <p class="has-text-right">
                          <help-button-component :url="`${domain}media/help/datasets.pdf`" as_icon="true"></help-button-component>
                        </p>
                    </div>
                </div>
                
                <!-- First Column -->
                <div class="columns is-mobile is-centered">
                    <div class="column">                 
                        <section>
                            <b-collapse class="panel" :open.sync="isOpenActive">
                                <div slot="trigger" class="panel-heading">
                                    <p class="has-text-left">Active Experimental Datasets</p>
                                </div>

                                <div class="panel-block">
                                    <div class="container">
                                        <!-- search start -->
                                        <b-field>
                                            <b-input v-model="keyword" type="search" placeholder="Search names..." expanded>
                                                <button class="button is-primary">Search names...</button>
                                            </b-input>
                                        </b-field>
                                        <!-- search end -->


                                        <!-- Active Data -->
                                        <section>
                                            <!-- TableComponent -->
                                            <table-component :tableData="activeItems" :keyword="keyword" @view="overviewResult"
                                             :customColumns="customColumns">
                                                <span class="" slot="actionButtons" slot-scope="props">
                                                    <span>
                                                        <view-icon-button-component :row_data="props.tableRow.row" @view="viewExperimentalDataset"></view-icon-button-component>
                                                        <span style="margin-right:10px"></span>
                                                    </span>

                                                    <span v-if="props.tableRow.row.status!='LOCKED'">
                                                        <upload-icon-button-component :row_data="props.tableRow.row" @upload="uploadExperimentalDataset"></upload-icon-button-component>
                                                        <span style="margin-right:10px"></span>
                                                    </span>

                                                    <span>
                                                        <overview-icon-button-component  :row_data="props.tableRow.row" @overview="overviewResult"></overview-icon-button-component>
                                                        <span style="margin-right:10px"></span>
                                                    </span>

                                                    <span v-if="props.tableRow.row.status!='LOCKED' && props.tableRow.row.status!='COMPLETED'">
                                                        <complete-icon-button-component @complete="completeExperimentalDataset" :row_data="props.tableRow.row" ></complete-icon-button-component>
                                                        <span style="margin-right:10px"></span>
                                                    </span> 
                                                    
                                                    <span>
                                                        <duplicate-icon-button-component :row_data="props.tableRow.row" @duplicate="isDuplicateModalActive = true; currentDatasetName = props.tableRow.row.name; duplicateDatasetButtonClick(props.tableRow.row)"></duplicate-icon-button-component>    
                                                        <span style="margin-right:10px"></span>
                                                    </span>

                                                    <span v-if="props.tableRow.row.status!='LOCKED'">
                                                        <archive-icon-button-component @archive="archiveExperimentalDataset" :row_data="props.tableRow.row" ></archive-icon-button-component>
                                                    </span>            
                                                </span>
                                            </table-component>
                                            <!-- /TableComponent -->
                                        </section>
                                        <!-- Active Data end -->
                                    </div>
                                </div>
                            </b-collapse>
                        </section>
                    </div>
                </div>

                <!-- Second Column -->
                <div class="columns is-mobile is-centered">
                    <div class="column">                 
                        <section>
                            <b-collapse class="panel" :open.sync="isOpenArchived">
                                <div slot="trigger" class="panel-heading">
                                    <p class="has-text-left">Archived ExperimentalDatasets</p>
                                </div>

                                <div class="panel-block">
                                    <div class="container">
                                        <!-- search start -->
                                        <b-field>
                                            <b-input v-model="archiveKeyword" type="search" placeholder="Search names..." expanded>
                                                <button class="button is-primary">Search names...</button>
                                            </b-input>
                                        </b-field>
                                        <!-- search end -->

                                        <!-- Archive Data -->
                                        <section>
                                            <!-- TableComponent -->
                                            <table-component :tableData="archivedItems" :keyword="archiveKeyword" :customColumns="customColumns">
                                                <span class="" slot="actionButtons" slot-scope="props">            
                                                    <duplicate-icon-button-component :row_data="props.tableRow.row" @duplicate="isDuplicateModalActive = true; currentDatasetName = props.tableRow.row.name; duplicateDatasetButtonClick(props.tableRow.row)"></duplicate-icon-button-component>     
                                                </span>
                                            </table-component>
                                            <!-- /TableComponent -->
                                        </section>
                                        <!-- Archive Data end -->
                                    </div>
                                </div>
                            </b-collapse>
                        </section>
                    </div>
                </div>
            </div>
        </section>


        <!-- Modal Start -->
        <b-modal :active.sync="isDuplicateModalActive">
          <section class="modal-card-body">
              <p class="subtitle is-uppercase box">Duplicate Experimental Dataset</p>
              <div class="columns has-text-left">
                  <div class="column is-one-third">
                      <p class="has-text-weight-bold">Existing Dataset Name:</p>
                  </div>
                  <div class="column">
                      {{currentDatasetName}}
                  </div>
              </div>
                <b-field class="has-text-left" label="Dataset Name:">
                    <b-input
                        type="text"
                        v-model="duplicateDatasetName"
                        placeholder="Enter the new name for the duplicate dataset..."
                        required>
                    </b-input>
                </b-field>
            </section>  

            <footer class="modal-card-foot has-text-right">
                <button v-on:click="duplicateDataset" class="button is-primary is-fullwidth">Duplicate</button>
                <button v-on:click="isDuplicateModalActive = false" class="button is-fullwidth">Cancel</button>
            </footer>
        </b-modal>
        <!-- Modal End -->


        <router-link to="/new-experimental-dataset">
            <new-float-button-component :tooltipMessage="'Create a new dataset'"></new-float-button-component>
        </router-link>

    </div>    
</template>

<script>
import TableComponent from '../features/tables/TableComponent'
import ViewIconButtonComponent from '../features/buttons/ViewIconButtonComponent'
import OverviewIconButtonComponent from '../features/buttons/OverviewIconButtonComponent'
import UploadIconButtonComponent from '../features/buttons/UploadIconButtonComponent'
import DuplicateIconButtonComponent from '../features/buttons/DuplicateIconButtonComponent'
import ArchiveIconButtonComponent from '../features/buttons/ArchiveIconButtonComponent'
import CompleteIconButtonComponent from '../features/buttons/CompleteIconButtonComponent'
import NewFloatButtonComponent from '../features/buttons/NewFloatButtonComponent'
import HelpButtonComponent from '../features/buttons/HelpButtonComponent'
import { mapGetters } from 'vuex'
export default {
    name: "ExperimentalDatasetsComponent",
    components: {
        TableComponent,
        ViewIconButtonComponent,
        UploadIconButtonComponent,
        DuplicateIconButtonComponent,
        ArchiveIconButtonComponent,
        NewFloatButtonComponent,
        OverviewIconButtonComponent,
        CompleteIconButtonComponent,
        HelpButtonComponent
    },
    props: ["activeExperimentalDatasets", "archivedExperimentalDatasets"],
    data() {
        return {
            // Duplicate Modal
            isDuplicateModalActive: false,
            currentDatasetName: '',
            duplicateDatasetName: '',
            //
            keyword: '',          
            archiveKeyword:'',  
            isEmpty: false,
            isLoading: false,
            isOpenActive: true,
            isOpenArchived: false,
            // floating button start
            bgColor: '#00CD66', //#7957d5
            position: 'bottom-right',
            addtooltip: "Add A New Experimental Dataset",
            // floating button end
            
            // list of custom column values and their column lables
            customColumns: [
                {value:'experimental_plan', lable:'Experimental Plan'}
            ]
        }
    },
    computed: {
        ...mapGetters([
            'domain'
        ]),
		activeItems () {
			return this.keyword
				? this.activeExperimentalDatasets.filter(item => item.name.toLowerCase().includes(this.keyword.toLowerCase()) || item.status.toLowerCase().includes(this.keyword.toLowerCase()))
				: this.activeExperimentalDatasets
		},
		archivedItems () {
			return this.archiveKeyword
				? this.archivedExperimentalDatasets.filter(item => item.name.toLowerCase().includes(this.archiveKeyword.toLowerCase()) || item.status.toLowerCase().includes(this.archiveKeyword.toLowerCase()))
				: this.archivedExperimentalDatasets
		}
	},
    methods:{
        cache(){
            // console.log('Cache Cleared');
        },
        alert(){
            alert('Clicked on alert icon');
        },
        viewExperimentalDataset: function (currentExperimentalDataset) {
            // console.log("view btn clicked for: ", currentExperimentalDataset.name)
            this.$emit("viewExperimentalDataset", currentExperimentalDataset);
        },
        uploadExperimentalDataset: function (currentExperimentalDataset) {
            // console.log("upload btn clicked for: ", currentExperimentalDataset.name)
            this.$emit("uploadExperimentalDataset", currentExperimentalDataset);
        },
        duplicateDatasetButtonClick: function(currentDataset){
            this.duplicateCurrentDataset = currentDataset        
            // console.log("name old: ", this.duplicateCurrentDataset)
        },
        duplicateDataset: function(){
            this.duplicateCurrentDataset.name = this.duplicateDatasetName
            this.$emit("duplicateDataset", this.duplicateCurrentDataset);         
            console.log("name change: ", this.duplicateCurrentDataset)
            this.isDuplicateModalActive = false
        },
        archiveExperimentalDataset: function(currentExperimentalDataset) {
            this.$dialog.confirm({
                title: 'Archive Dataset',
                message: 'Are you sure you want to <b>archive</b> this Dataset? This action cannot be undone.',
                confirmText: 'Archive Dataset',
                type: 'is-warning',
                hasIcon: true,
                onConfirm: () => this.$emit("archiveExperimentalDataset", currentExperimentalDataset)
            })  
        }, 
        overviewResult: function(currentExperimentalDataset) {
            this.$emit("overviewResult", currentExperimentalDataset)
        }, 
        completeExperimentalDataset: function(currentExperimentalDataset) {
            this.$emit("completeExperimentalDataset", currentExperimentalDataset)
        }
    }
}
</script>

